// src/data/products.js
const products = [
  {
    id: 1,
    name: "Blue T‑Shirt",
    price: 19.99,
    img: "/assets/tshirt-blue.jpg",
    description:
      "Soft cotton T‑shirt in a vibrant blue. Perfect for casual wear.",
  },
  {
    id: 2,
    name: "Red Hoodie",
    price: 39.99,
    img: "/assets/hoodie-red.jpg",
    description:
      "Cozy fleece hoodie with a bold red color and front pocket.",
  },
  {
    id: 3,
    name: "Sneakers",
    price: 59.99,
    img: "/assets/sneakers.jpg",
    description: "Lightweight canvas sneakers, great for everyday use.",
  },
  // add as many as you like …
];
export default products;